import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.172 7.858a5.598 5.598 0 1 0-10.344 4.284 5.598 5.598 0 0 0 10.344-4.284Zm-7.85-4.324a6.998 6.998 0 1 1 5.356 12.932A6.998 6.998 0 0 1 7.322 3.534Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.643 6.75c.285.01.536.19.636.458l1.299 3.482.439-.98a.703.703 0 0 1 .64-.417h1.14c.388 0 .703.317.703.707 0 .39-.315.707-.703.707h-.684l-.953 2.126a.703.703 0 0 1-1.3-.041L9.561 9.31l-.439.98a.703.703 0 0 1-.64.417H6.202A.705.705 0 0 1 5.5 10c0-.39.315-.707.703-.707h1.824l.952-2.126a.703.703 0 0 1 .664-.417Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
